import { SPACES, lightColorPalette } from '@linearb/linui-common';
import styled from 'styled-components';

export const StyledBackground = styled.div`
  background-color: ${lightColorPalette.lbBlue_10};
  padding: ${SPACES.small};
`;

export const FullHeightGrid = styled.main`
  display: grid;
  grid-template-columns: 18vw auto;
  grid-auto-rows: fit-content(80vh);
  gap: 0px 0px;
  grid-template-areas: '. .';
  background-color: ${lightColorPalette.lbWhite};
  width: 100%;
`;

export const StyledMetricsContainer = styled.div`
  background: ${lightColorPalette.lbWhite};
`;
